import { render, staticRenderFns } from "./CourseLesson.vue?vue&type=template&id=2b9cf0f2&scoped=true"
import script from "./CourseLesson.vue?vue&type=script&lang=js"
export * from "./CourseLesson.vue?vue&type=script&lang=js"
import style0 from "./CourseLesson.vue?vue&type=style&index=0&id=2b9cf0f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9cf0f2",
  null
  
)

export default component.exports